import LogRocket from 'logrocket'
import { bugsnagClient, LOGROCKET_API_KEY } from '../constants/AppConstants'
class LogrocketConfig {
  init() {
    if (!LOGROCKET_API_KEY) {
      //nothing to do. return
      return
    }
    const self = this
    LogRocket.init(LOGROCKET_API_KEY, {
      network: {
        requestSanitizer: function(request) {
          self.sanitizeSignIn(request)
          self.sanitizeSignup(request)
          self.sanitizeUpdateProfile(request)
          self.sanitizeResetPassword(request)
          return request
        }
      }
    })

    bugsnagClient.beforeSend = function(report) {
      report.metaData.sessionURL = LogRocket.sessionURL
      return report
    }
  }

  sanitizeSignIn(request) {
    if (this.urlContains(request, '/signin')) {
      this.scrubPassword(request)
    }
  }

  sanitizeSignup(request) {
    if (this.urlContains(request, '/signup')) {
      this.scrubPassword(request)
    }
  }

  sanitizeUpdateProfile(request) {
    if (this.urlContains(request, '/users')) {
      this.scrubCreditCard(request)
    }
  }

  sanitizeResetPassword(request) {
    if (this.urlContains(request, '/resetpassword')) {
      this.scrubPassword(request)
    }
  }

  scrubPassword(request) {
    try {
      if (request.body) {
        let jsonbody = JSON.parse(request.body)
        if (jsonbody && jsonbody.password) {
          jsonbody.password = undefined
          request.body = JSON.stringify(jsonbody)
        }
      }
    } catch (err) {
      console.log('error sanitizing data ' + err)
    }
  }

  scrubCreditCard(request) {
    try {
      if (request.body) {
        let jsonbody = JSON.parse(request.body)
        if (jsonbody && jsonbody.paymentInfo) {
          jsonbody.paymentInfo = undefined
          request.body = JSON.stringify(jsonbody)
        }
      }
    } catch (err) {
      console.log('error sanitizing data ' + err)
    }
  }

  urlContains(request, searchText) {
    return request.url.toLowerCase().indexOf(searchText) !== -1
  }
}
export default new LogrocketConfig()



// WEBPACK FOOTER //
// ./src/utils/LogrocketConfig.js